import { Prisma } from '@repo/database/src/types';
import { Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

class FilterTableDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  game?: string;

  @IsOptional()
  @IsString()
  type?: string;

  @IsOptional()
  @IsInt()
  @Transform(({ value }) => parseInt(value, 10))
  maxPlayers?: number;

  @IsOptional()
  @IsInt()
  @Transform(({ value }) => parseInt(value, 10))
  seatCount?: number;

  @IsOptional()
  @IsInt()
  @Transform(({ value }) => parseInt(value, 10))
  waitlist?: number;

  @IsOptional()
  @IsBoolean()
  isPublic?: boolean;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => parseFloat(value))
  minBuyin?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => parseFloat(value))
  maxBuyin?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => parseFloat(value))
  minStake?: number;

  @IsOptional()
  @IsNumber()
  @Transform(({ value }) => parseFloat(value))
  maxStake?: number;

  @IsOptional()
  @IsString()
  status?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  @Transform(({ value }) => (Array.isArray(value) ? value : [value]))
  variants?: string[];
}

class Sorts {
  @IsString()
  @IsNotEmpty()
  field: string;

  @IsString()
  @IsEnum(Prisma.SortOrder)
  order: Prisma.SortOrder;
}

export class GetTableDto {
  @Type(() => FilterTableDto)
  @ValidateNested()
  filter?: FilterTableDto;
  @IsInt()
  skip: number;
  @IsInt()
  take: number;
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => Sorts)
  @IsOptional()
  sorts?: Sorts[];
}
